import {
  Popover,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

/** Question-mark button explaining why open / click figures are approximate */
export function TrackingHelpPopover() {
  return (
    <Popover className={ `relative inline-flex` }>
      <PopoverButton
        type={ `button` }
        aria-label={ `How open and click tracking works` }
        className={ `rounded-full text-gray-400 hover:text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-paidniceGreen-500` }
      >
        <QuestionMarkCircleIcon className={ `h-4 w-4` } />
      </PopoverButton>
      <PopoverPanel
        anchor={ `bottom start` }
        className={ `z-20 w-72 rounded-lg border border-gray-200 bg-white p-3.5 text-xs text-gray-600 shadow-xl [--anchor-gap:6px]` }
      >
        <div className={ `mb-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400` }>{ `Best-effort tracking` }</div>
        { `Opens and clicks rely on a tracking pixel and rewritten links. Some email clients and security tools block the pixel or pre-fetch links (for example Apple Mail privacy protection and corporate link scanners), so these figures can be under- or over-reported. Sent, delivery and payment figures are not affected.` }
      </PopoverPanel>
    </Popover>
  );
}
